import React from 'react';
import SettingsSaveButton from '../SettingsSaveButton';

const PliseSettings = React.memo(({
  pliseExtras,
  setPliseExtras,
  handleSaveSettings,
  isSavingSettings
}) => {
  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <div className="settings-card-title">
          <i className="fas fa-tools"></i>
          <div className="settings-card-title-text">
            <h4>Üretim Montaj Seçenekleri Ek Ücret Ayarları (₺)</h4>
            <span className="settings-card-subtitle">Plise siparişlerinde kullanılan ek montaj ücretleri</span>
          </div>
        </div>
        <SettingsSaveButton
          onClick={() => handleSaveSettings()}
          isSaving={isSavingSettings}
        />
      </div>

      <div className="settings-fields-grid settings-fields-grid--compact">
        <div className="form-group">
          <label>Pratik Montaj</label>
          <div className="settings-input-wrap">
            <input
              type="number"
              value={pliseExtras.pratikMontaj}
              onChange={(e) => setPliseExtras(p => ({ ...p, pratikMontaj: e.target.value }))}
              placeholder="0"
            />
            <span className="settings-input-suffix">₺</span>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PliseSettings;
